import React from 'react';
import { Card } from 'react-bootstrap';

const Linha = ({ label, value }) => (
  <div className="d-flex justify-content-between small py-1 border-bottom">
    <span className="text-muted">{label}</span>
    <span>{value == null || value === '' ? '—' : value}</span>
  </div>
);

const CardCotacao = ({ linha, exibirCotacao2, fmt4, fmt5, fmtData }) => (
  <Card className="mb-2">
    <Card.Body className="p-2">
      <Card.Title className="h6 mb-2">{fmtData(linha.data)}</Card.Title>
      <Linha label="Cotação" value={fmt4(linha.cotacao)} />
      <Linha label="Var. Acum. (%)" value={fmt4(linha.variacao_acumulada)} />
      <Linha label="Var. Mensal (%)" value={fmt4(linha.variacao_mensal)} />
      <Linha label="Var. Anual (%)" value={fmt4(linha.variacao_anual)} />
      {exibirCotacao2 && (
        <>
          <hr className="my-2" />
          <Linha label="Cotação 2" value={fmt5(linha.cotacao2)} />
          <Linha label="Var. Acum. 2 (%)" value={fmt5(linha.variacao_acumulada2)} />
          <Linha label="Var. Mensal 2 (%)" value={fmt5(linha.variacao_mensal2)} />
          <Linha label="Var. Anual 2 (%)" value={fmt5(linha.variacao_anual2)} />
        </>
      )}
    </Card.Body>
  </Card>
);

export default CardCotacao;
